import getIn from 'transmute/getIn';
import { THREADLIST_MEMBER_MULTI_SELECT } from '../constants/keyPaths';
export const getThreadListMembersBatchUpdates = getIn(THREADLIST_MEMBER_MULTI_SELECT);